/**
 * ALLIN Cart Page enhancements
 * - Toggles `.is-min-qty` on cart items at qty=1 (so the minus button
 *   shows a trash icon, signalling that one more press will remove it).
 * - Plays a fade/slide animation when an item is removed. Capture-phase
 *   click on the remove button schedules the animation, then theme's
 *   cart.js still does the AJAX request — so the animation runs while
 *   the request is in flight.
 * - Smooths the inline replace of `.js-contents` so newly-rendered items
 *   fade in.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Toggle .is-min-qty so CSS can swap minus icon → trash icon.
  function syncMinQtyClasses(root) {
    var scope = root || document;
    scope.querySelectorAll('.allin-cart-item').forEach(function (item) {
      var input = item.querySelector('.allin-cart-item__qty-input');
      if (!input) return;
      var v = parseInt(input.value, 10);
      item.classList.toggle('is-min-qty', !isNaN(v) && v <= 1);
    });
  }

  // Capture-phase listener: runs before cart.js's bubble-phase handler,
  // so we can mark the row as "removing" before the AJAX kicks off.
  function onRemoveClick(e) {
    var btn = e.target.closest && e.target.closest('cart-remove-button');
    if (!btn) return;
    var item = btn.closest('.allin-cart-item');
    if (item) item.classList.add('is-removing');
  }

  // Same idea for the minus button at qty=1: cart.js sets quantity to 0
  // (which removes the line) — we visually mark the row first so the
  // user sees a smooth fade-out instead of an abrupt collapse.
  function onMinusClick(e) {
    var btn = e.target.closest && e.target.closest('.allin-cart-item__qty-btn--minus');
    if (!btn) return;
    var item = btn.closest('.allin-cart-item');
    if (!item) return;
    if (item.classList.contains('is-min-qty')) {
      item.classList.add('is-removing');
    }
  }

  // After cart.js replaces .js-contents, freshly-inserted .allin-cart-item
  // elements should fade in.
  function onCartContentsMutated() {
    document.querySelectorAll('.allin-cart-item:not(.is-removing):not(.is-mounted)').forEach(function (item) {
      item.classList.add('is-mounted');
    });
  }

  // Cart count badge — sum quantities across all line items + pulse on change.
  function updateCartCount() {
    var countEl = document.querySelector('.allin-cart__count');
    if (!countEl) return;
    var total = 0;
    document.querySelectorAll('#main-cart-items .allin-cart-item__qty-input').forEach(function (inp) {
      var v = parseInt(inp.value, 10);
      if (!isNaN(v) && v > 0) total += v;
    });
    var newText = String(total);
    if (countEl.textContent.trim() !== newText) {
      countEl.textContent = newText;
      countEl.classList.remove('is-pulsing');
      // restart animation
      // eslint-disable-next-line no-unused-expressions
      countEl.offsetWidth;
      countEl.classList.add('is-pulsing');
      setTimeout(function () { countEl.classList.remove('is-pulsing'); }, 500);
    }
  }

  // Auto-hide the recommendations block if it stayed empty after lazy load.
  function maybeHideRecs() {
    document.querySelectorAll('product-recommendations.allin-cart__recs').forEach(function (rec) {
      if (rec.dataset.allinHidden === '1') return;
      // If after lazy fetch it has any rec card → show; otherwise after a
      // grace period → keep hidden via :empty (CSS) or explicit hide.
      if (rec.querySelector('.allin-cart__rec-card')) {
        rec.style.display = '';
        return;
      }
      // No card yet — give the lazy fetch up to 6s, then accept it as empty.
      if (!rec.dataset.allinTimer) {
        rec.dataset.allinTimer = '1';
        setTimeout(function () {
          if (!rec.querySelector('.allin-cart__rec-card')) {
            rec.style.display = 'none';
            rec.dataset.allinHidden = '1';
          }
        }, 6000);
      }
    });
  }

  ready(function () {
    var contents = document.querySelector('#main-cart-items .js-contents');
    if (!contents) return;

    // Initial sync
    syncMinQtyClasses();
    onCartContentsMutated();
    updateCartCount();
    maybeHideRecs();

    // Watch for input changes to update min-qty class + count live.
    contents.addEventListener('input', function (e) {
      if (e.target && e.target.matches && e.target.matches('.allin-cart-item__qty-input')) {
        syncMinQtyClasses();
        updateCartCount();
      }
    });
    contents.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('.allin-cart-item__qty-input')) {
        syncMinQtyClasses();
        updateCartCount();
      }
    });

    // Capture-phase remove animation hooks.
    document.addEventListener('click', onRemoveClick, true);
    document.addEventListener('click', onMinusClick, true);

    // After AJAX cart updates, re-run sync + mount-in animation + count.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        requestAnimationFrame(function () {
          syncMinQtyClasses();
          onCartContentsMutated();
          updateCartCount();
          maybeHideRecs();
        });
      });
    }

    // Belt & suspenders: MutationObserver for any DOM swap inside js-contents.
    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        syncMinQtyClasses();
        onCartContentsMutated();
        updateCartCount();
      });
      mo.observe(contents, { childList: true, subtree: true });

      // Watch the recommendations element for lazy-load completion.
      document.querySelectorAll('product-recommendations.allin-cart__recs').forEach(function (rec) {
        var ro = new MutationObserver(function () { maybeHideRecs(); });
        ro.observe(rec, { childList: true, subtree: true });
      });
    }
  });
})();
